
import fetch from '@/service/fetch';

// 用户列表
export const userList = async (params) => {
  const res = await fetch.get('/system/user/list')(params);
  return res.data;
};

// 无权限点用户列表
export const userListChose = async (params) => {
  const res = await fetch.get('/system/user/listChose')(params);
  return res.data;
};

// 新增用户
export const addUser = async (params) => {
  const res = await fetch.post('/system/user/add')(params);
  return res.data;
}

// 编辑用户
export const editUser = async (params) => {
  const res = await fetch.post('/system/user/edit')(params);
  return res.data;
}

// 删除用户
export const deleteUser = async (params) => {
  const payload = typeof params === 'number' ? { id: params } : params;
  const res = await fetch.post('/system/user/delete')(payload);
  return res.data;
}

// 用户详情
export const getUserDetail = async (id) => {
  const res = await fetch.get('/system/user/detail')({ id });
  return res.data;
}

// 用户停用/启用
export const changeStatus = async (params) => {
  const res = await fetch.post('/system/user/changeStatus')(params);
  return res.data;
}

// 用户停结算状态切换（仅ROOT/超级管理员）
export const changeStopSettlement = async (params) => {
  const res = await fetch.post('/system/user/changeStopSettlement')(params);
  return res.data;
}

// 重置密码
export const resetPwd = async (params) => {
  const res = await fetch.post('/system/user/resetPsw')(params);
  return res.data;
}

// 新增or编辑 校验手机号码
export const validPhone = async (params) => {
  const res = await fetch.post('')(params);
  return res.data;
}

// 分配角色
export const assignRole = async (params) => {
  const res = await fetch.post('')(params);
  return res.data;
}


// 修改密码
export const editPwd = async (params) => {
  const res = await fetch.post('/system/user/changePwd')(params);
  return res.data;
}
